<div class="d-flex" style="gap: 2px;width: max-content;">
    {{data[header.field]}}
    <button *ngIf="this.reportName === 'Brandstudio_Replenishment'" style="width: 20px;height: 20px;" mat-icon-button
        color="primary" (click)="onEditCobject(data, $event)">
        <mat-icon style="font-size: 18px;line-height: 0.9;">edit</mat-icon>
    </button>
</div>